export default __webpack_public_path__ + "static/media/pic17.f8f05db3.jpg";